import React from 'react';
import { useContent } from '../lib/ContentContext';
import { PageHero } from '../components/site/PageHero';
import { NewsCards } from '../components/site/NewsCards';

export default function News() {
  const { content } = useContent();
  const page = content?.news_page;
  if (!page) return null;

  return (
    <div>
      <PageHero title={page.hero_title} subtitle={page.hero_subtitle} image={page.hero_image} />
      <section className="py-14 sm:py-20 bg-[#F6F7F9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <NewsCards />
        </div>
      </section>
    </div>
  );
}
